import { getBackendUrl } from "../../config";

// Fluxo pronto de recrutamento: boas-vindas -> escolhe a vaga (Vendas,
// Marketing ou falar com o RH). Cada vaga manda o post (imagem) com o resumo,
// pergunta se quer participar e entra na IA com a instrução daquela vaga.

export const NOME_MODELO_RH = "Recrutamento — Estágio Vendas e Marketing";

const urlPublica = (arquivo) => {
  const base = String(getBackendUrl() || "").replace(/\/+$/, "");
  return `${base}/public/${arquivo}`;
};

export const INSTRUCAO_VENDAS =
  "O candidato escolheu a VAGA DE ESTÁGIO EM VENDAS (Área Comercial) e já viu a imagem e o resumo da vaga. " +
  "Não repita a saudação nem o resumo. Peça o currículo (só solicite: não diga que é opcional nem cite formato de arquivo). " +
  "Leia o currículo, se vier. Depois faça a ÚNICA pergunta da triagem (ou só confirme, se o currículo já mostrar): se está " +
  "cursando o Ensino Médio ou uma faculdade em Administração, Gestão Comercial, Processos Gerenciais, Marketing, Gestão " +
  "Financeira, Ciências Contábeis ou Economia. Se se encaixar, mande os dias da entrevista online direto, sem perguntar " +
  "período; depois que ele escolher o dia, mande os horários daquele dia. No agendamento, vaga = \"Estágio em Vendas\".";

export const INSTRUCAO_MARKETING =
  "O candidato escolheu a VAGA DE ESTÁGIO EM MARKETING e já viu a imagem e o resumo da vaga. " +
  "Não repita a saudação nem o resumo. Peça o currículo OU o portfólio/site com os trabalhos (Instagram, Behance, site) — " +
  "só solicite: não diga que é opcional nem cite formato de arquivo. Leia o que ele mandar. Se mostrar que ele cursa o " +
  "Ensino Médio ou faculdade em Marketing, Publicidade e Propaganda, Comunicação Social, Design, Administração ou área " +
  "relacionada, só confirme. Se NÃO mostrar faculdade nessa área (ou se ele não mandar nada), pergunte se ele faz ou já fez " +
  "algum curso, ou já trabalhou com algo ligado a marketing, design ou redes sociais. Se sim, ele se encaixa: mande os dias " +
  "da entrevista online direto, sem perguntar período; depois que ele escolher o dia, mande os horários daquele dia. " +
  "No agendamento, vaga = \"Estágio em Marketing\".";

const BENEFICIOS_VENDAS =
  "• Bolsa de *R$ 1.500,00/mês* + VR R$ 15/dia + VT R$ 11/dia + bonificação por metas\n" +
  "• Das 8h às 16h, com 1h30 de almoço";

const BENEFICIOS_MARKETING =
  "• Bolsa de *R$ 1.600,00/mês* + VR R$ 15/dia + VT R$ 11/dia + bonificação por metas\n" +
  "• Das 8h às 16h, com 1h30 de almoço";

export const montarFluxoRH = () => {
  const imgVendas = "fluxo-vaga-estagio-consigtech.png";
  const imgMkt = "fluxo-vaga-estagio-marketing.jpg";

  const nodes = [
    { id: "start", type: "startNode", position: { x: 420, y: 0 }, data: {} },
    {
      id: "node_1",
      type: "textNode",
      position: { x: 340, y: 110 },
      data: {
        text:
          "Olá! 👋 Seja muito bem-vindo(a) ao *RH da Consig Tech Promotora*! 💚\n\n" +
          "Que bom ter você por aqui. Temos vagas de estágio abertas e você já pode agendar a sua entrevista online.",
        waitForReply: false,
      },
    },
    {
      id: "node_2",
      type: "menuNode",
      position: { x: 320, y: 300 },
      data: {
        text: "Para qual vaga você quer se candidatar?",
        options: ["Estágio em Vendas", "Estágio em Marketing", "Falar com alguém do RH"],
      },
    },
    // ---------- Vendas ----------
    {
      id: "node_3",
      type: "textNode",
      position: { x: -260, y: 560 },
      data: {
        imagem: imgVendas,
        imagemUrl: urlPublica(imgVendas),
        text:
          "🚀 *Estágio em Vendas — Área Comercial*\n\n" +
          "• Atendimento e vendas pelo WhatsApp (*não é telemarketing*)\n" +
          BENEFICIOS_VENDAS +
          "\n• Para quem está no Ensino Médio ou cursa Administração, Gestão Comercial, Processos Gerenciais, " +
          "Marketing, Gestão Financeira, Ciências Contábeis ou Economia",
        waitForReply: false,
      },
    },
    {
      id: "node_4",
      type: "menuNode",
      position: { x: -260, y: 920 },
      data: {
        text: "Você tem interesse em participar do processo seletivo para *Estágio em Vendas*?",
        options: ["Sim, quero participar", "Não, obrigado(a)"],
      },
    },
    { id: "node_5", type: "aiNode", position: { x: -420, y: 1160 }, data: { instrucao: INSTRUCAO_VENDAS } },
    // ---------- Marketing ----------
    {
      id: "node_6",
      type: "textNode",
      position: { x: 300, y: 560 },
      data: {
        imagem: imgMkt,
        imagemUrl: urlPublica(imgMkt),
        text:
          "📣 *Estágio em Marketing*\n\n" +
          "• Redes sociais, endomarketing, campanhas e produção de conteúdo\n" +
          BENEFICIOS_MARKETING +
          "\n• Para quem está no Ensino Médio ou cursa Marketing, Publicidade e Propaganda, Comunicação Social, " +
          "Design, Administração ou áreas relacionadas",
        waitForReply: false,
      },
    },
    {
      id: "node_7",
      type: "menuNode",
      position: { x: 300, y: 920 },
      data: {
        text: "Você tem interesse em participar do processo seletivo para *Estágio em Marketing*?",
        options: ["Sim, quero participar", "Não, obrigado(a)"],
      },
    },
    { id: "node_8", type: "aiNode", position: { x: 140, y: 1160 }, data: { instrucao: INSTRUCAO_MARKETING } },
    // ---------- comuns ----------
    {
      id: "node_9",
      type: "textNode",
      position: { x: 0, y: 1360 },
      data: {
        text:
          "Sem problemas! 😊 Se mudar de ideia ou quiser conhecer a outra vaga, é só mandar uma mensagem aqui. Boa sorte!",
        waitForReply: false,
      },
    },
    { id: "node_10", type: "humanNode", position: { x: 860, y: 560 }, data: {} },
  ];

  const aresta = (source, target, sourceHandle = null) => ({
    id: `e_${source}-${sourceHandle || "bottom"}-${target}`,
    source,
    sourceHandle,
    target,
    targetHandle: null,
  });

  const edges = [
    aresta("start", "node_1"),
    aresta("node_1", "node_2"),
    aresta("node_2", "node_3", "option_0"),
    aresta("node_2", "node_6", "option_1"),
    aresta("node_2", "node_10", "option_2"),
    aresta("node_3", "node_4"),
    aresta("node_4", "node_5", "option_0"),
    aresta("node_4", "node_9", "option_1"),
    aresta("node_6", "node_7"),
    aresta("node_7", "node_8", "option_0"),
    aresta("node_7", "node_9", "option_1"),
  ];

  return { nodes, edges };
};
